var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('product-form',{attrs:{"product":_vm.product,"action":"post"},on:{"update-price":(value) => { _vm.product.price = value}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }